<template>
  <div class="container">
    <h1 class="subs-title">{{ getTitle() }}</h1>
    <text-field v-model="form.name" :validator="$v.form.name" label="Subscription name*" />
    <div class="input-container">
      <datetime-field
        v-model="form.from"
        :validator="$v.form.from"
        style="width: 100%"
        label="From*"
        :min="new Date().toString()"
        :error-messages="{
          minDate: 'Start date must be a future date',
          maxDate: 'Start date should be before the end of the event',
        }"
      />
      <datetime-field
        v-model="form.to"
        :validator="$v.form.to"
        style="width: 100%"
        label="To*"
        :min="form.from ? form.from.toString() : new Date().toString()"
        :error-messages="{
          minDate: 'End date should not be before the start of the event',
        }"
      />
    </div>
    <div class="input-container">
      <text-field
        v-model.number="form.price"
        :validator="$v.form.price"
        type="number"
        step="0.01"
        label="Price (EUR)*"
      />
    </div>
    <textarea-field
      v-model="form.description"
      :validator="$v.form.description"
      label="Description"
      height="13.75rem"
    />
    <h2 class="second-title">Included events</h2>
    <p class="description">
      You can add tickets for performances by events name or by preferences.
    </p>
    <div v-for="(item, index) in $v.form.couponItems.$each.$iter" :key="item.externalId">
      <subscription-item
        :coupon-item="item"
        :event-templates="eventTemplates"
        :interests="interests"
        :index="parseInt(index)"
        :vs="item"
        @updateCouponItem="updateCouponItem($event)"
        @removeSubscriptionItem="removeSubscriptionItem(item.externalId)"
      />
    </div>

    <main-button style="margin-top: 8px; width: 290px" flat depressed @click="addSubscriptionItem">
      <span class="add-symbol">+</span>Add ticket for event
    </main-button>
    <div class="buttons-wrapper" style="margin-top: 58px">
      <main-button text="CANCEL" flat depressed @click="$emit('cancel')" />
      <div class="buttons">
        <main-button :text="buttonName" @click="handleCreate" />
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import { submitGuard } from '@/utils'
import { v4 as uuid } from 'uuid'
import SubscriptionItem from '@/components/organizations/subscriptions/SubscriptionItem.vue'

export default {
  name: 'create-or-edit-subscription-plan',
  components: {
    SubscriptionItem,
  },
  props: {
    organizationSlug: {
      type: String,
    },
    initialValue: {
      type: Object,
      default: () => {},
    },
    eventTemplates: {
      type: Array,
      default: () => [],
    },
    interests: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: { couponItems: [], ...cloneDeep(this.initialValue) },
      buttonName: 'Create plan',
      emitType: 'create',
      attendeeFields: {},
    }
  },
  // TODO - Finish validations
  validations() {
    return {
      form: {
        name: { required },
        price: { required },
        from: { required },
        to: { required },
        couponItems: {
          $each: {
            ticketAmount: { required },
            type: { required },
          },
        },
      },
    }
  },
  methods: {
    getTitle() {
      if (Object.keys(this.initialValue).length) {
        this.buttonName = 'Update'
        this.emitType = 'update'

        return 'Edit Subscription Plan'
      } else {
        return 'Create Subscription Plan'
      }
    },
    addSubscriptionItem() {
      this.form.couponItems.push({
        externalId: uuid(),
      })
    },
    removeSubscriptionItem(externalId) {
      this.form.couponItems.splice(
        this.form.couponItems.findIndex(item => item.externalId === externalId),
        1,
      )
    },
    updateCouponItem(info) {
      this.form.couponItems = this.form.couponItems.map(ci =>
        ci.externalId === info.externalId ? info : ci,
      )
    },
    handleCreate() {
      submitGuard(this, () => this.$emit(this.emitType, this.form))
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
}
.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.input-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  column-gap: 1.5rem;
}
.second-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #ff4c00;
  margin-bottom: 0.75rem;
  margin-top: 3rem;
}
</style>
